import React from 'react';

import { Outlet } from 'react-router-dom';

import { Header } from '../Header';
import { Footer } from '../Footer';
import { ModalAuth } from 'containers/ModalAuth';

import './Layout.scss';
import { MarketBanner } from 'components/Banners/MainMarketBanner';
import { CookiePrivacy } from 'components/CookiePrivacy';

export const Layout = ({
  withHeader = true,
  withFooter = true,
  withBanner = true,
  hideProfileInfo = true,
}) => {
  return (
    <div className="main-layout">
      {withHeader && <Header hideProfileInfo={hideProfileInfo} />}

      <div className="content-container">
        {withBanner && <MarketBanner position="top" />}
        <Outlet />
        {withBanner && <MarketBanner position="bottom" />}
      </div>

      {withFooter && <Footer />}
      <ModalAuth />
      <CookiePrivacy />
    </div>
  );
};
